var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCircularArrow = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 429.354 429.354",
    style: {
      enableBackground: "new 0 0 429.354 429.354"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M372.53,82.843C336.673,30.958,277.621-0.009,214.55,0C108.512,0.115,22.644,86.17,22.759,192.208 c0.107,98.751,75.105,181.317,173.392,190.888L163.638,415.6c-3.178,3.07-3.266,8.134-0.196,11.312 c3.07,3.178,8.134,3.266,11.312,0.196c0.067-0.064,0.132-0.13,0.196-0.196l45.248-45.248c0.747-0.745,1.337-1.632,1.736-2.608 c0.809-1.957,0.809-4.155,0-6.112c-0.399-0.976-0.989-1.863-1.736-2.608l-45.248-45.248c-3.178-3.07-8.243-2.982-11.312,0.196 c-2.994,3.1-2.994,8.015,0,11.116l30.4,30.4C97.56,355.44,28.559,268.019,39.919,171.541S138.7,6.061,235.178,17.422 s165.48,98.781,154.119,195.259c-5.908,50.177-33.107,95.39-74.667,124.119c-3.691,2.428-4.714,7.389-2.286,11.08 c2.429,3.691,7.389,4.714,11.08,2.286c0.105-0.069,0.208-0.141,0.31-0.214C410.969,289.666,432.815,170.078,372.53,82.843z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCircularArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/circular-arrow.324a4f2a.svg";
export { ForwardRef as ReactComponent };